import "./Auth.scss";
import block from "bem-cn";
import Button from "../Button/Button";
import menu from "./menu.svg";
import avatar from './avatar.svg';
import avatar1 from '../../images/avatars/avatar1.png';
import avatar2 from '../../images/avatars/avatar2.png';
import AvatarList from "../AvatarList/AvatarList";

const b = block("Auth");

type Props = {
  isAuth?: boolean;
};

const Auth = ({ isAuth = false }: Props) => {
  return (
    <div className={b({ "visually-hidden": isAuth })}>
      <div className={b("reg-wrapper")}>
        <div className={b('avatar-list')}>
          <AvatarList avatars={[{ image: avatar1, isOnline: true }, { image: avatar2 }, { image: avatar1, isOnline: true }, { image: avatar2 }]} />
        </div>
        <div className={b('wrapper3')}>
          <p className={b("reg-text")}>
            После регистрации можно посмотреть цены на услуги специалистов
          </p>
          <div className={b('buttons')}>
            <div className={b("Button-wrapper")}>
              <Button link="/sign-up" text="Регистрация" />
            </div>
            <div className={b("Button-wrapper")}>
              <Button link="/sign-in" text="Войти" />
            </div>
          </div>
        </div>
        <div
          className={b("after-sign-in").state({ "visually-hidden": !isAuth })}
        >
          <img className={b("avatar")} src={avatar} alt="avatar" />
          <span className={b("name")}>Константин</span>
          <img className={b("menu")} src={menu} alt="menu" />
        </div>
      </div>
    </div>
  );
};

export default Auth;
